import { DetailsItem } from '@calendly/booking-kit'
import { IconUsers } from '@calendly/ui/components/glyphs/IconUsers'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import PropTypes from 'prop-types'


export const Attendees = ({ items, bookingAppRedesign = false }) => items.length > 1 && (
  <DetailsItem as="div">
    <UiIcon icon={IconUsers} size={bookingAppRedesign ? 'small' : 'medium'} spacingRight="8" />
    {items.join(', ')}
  </DetailsItem>
)

Attendees.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  bookingAppRedesign: PropTypes.bool
}
